import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const PARTNERS = [
  {
    key: 'senac',
    logo: '/images/logo-senac.png', // Fallback, will display beautifully
    name: 'Senac — Incubadora I.D.E.I.A.S',
    desc: 'O Tarefas Perto integra o programa de incubação do Senac, recebendo suporte estratégico e mentorias para acelerar nosso crescimento no ecossistema de inovação.',
    items: [
      { label: 'Startup incubada pelo Senac PE' },
      { label: 'Estrutura física e técnica especializada' },
      { label: 'Mentorias e capacitações de mercado' },
      { label: 'Conexão ativa com investidores' },
    ],
  },
  {
    key: 'sebrae-startup-ne',
    logos: [
      { src: '/images/logo-sebrae.svg', alt: 'Sebrae' },
      { src: '/images/logo-startup-ne.avif', alt: 'Startup NE' },
    ],
    name: 'Sebrae + Startup NE',
    desc: 'Selecionados entre mais de 300 projetos no Nordeste, somos acelerados pelo programa Startup NE, consolidando nossa governança e modelo de negócio.',
    items: [
      { label: 'Entre as 80 startups selecionadas em PE' },
      { label: 'Aceleração estratégica de alto impacto' },
      { label: 'Foco em modelagem e tração real' },
      { label: 'Validação com grandes especialistas' },
    ],
  },
  {
    key: 'facepe',
    logo: '/images/logo-facepe.png',
    name: 'FACEPE — Apoio à Inovação',
    desc: 'Apoiados pelo Edital Pró-Startups da Fundação de Amparo à Ciência e Tecnologia de PE, recebendo bolsas para pesquisa e inovação tecnológica.',
    items: [
      { label: 'Edital Pró-Startups Operação' },
      { label: 'Bolsa para fomento e desenvolvimento em 2025' },
      { label: 'Foco em evolução tecnológica do produto' },
      { label: 'Apoio científico e governamental' },
    ],
  },
];

const SIMULATOR_SCREENS = [
  {
    id: 'buscar',
    title: '1. Buscar',
    subtitle: 'Encontre o que precisa',
    desc: 'O cliente abre o app e digita a necessidade (ex: "Encanador", "Aulas de Inglês"). A geolocalização exibe profissionais verificados a poucos metros de distância.',
    phoneTitle: 'Buscar Serviço',
    phoneColor: '#1e5af6',
    mockContent: (
      <div className="sim-phone__buscar">
        <div className="sim-phone__search-box">
          <i className="fas fa-search"></i>
          <span>Encanador próximo...</span>
        </div>
        <div className="sim-phone__results">
          <div className="sim-phone__item">
            <div className="sim-phone__avatar">R</div>
            <div className="sim-phone__item-info">
              <strong>Roberto Silva</strong>
              <span>Encanador · a 1.2 km de você</span>
              <div className="sim-phone__stars">★ 4.9 (42 avaliações)</div>
            </div>
          </div>
          <div className="sim-phone__item">
            <div className="sim-phone__avatar">M</div>
            <div className="sim-phone__item-info">
              <strong>Marcos Souza</strong>
              <span>Encanador · a 2.5 km de você</span>
              <div className="sim-phone__stars">★ 4.8 (19 avaliações)</div>
            </div>
          </div>
        </div>
      </div>
    )
  },
  {
    id: 'match',
    title: '2. Match com IA',
    subtitle: 'Conexão inteligente',
    desc: 'Nossos modelos de inteligência artificial analisam a reputação, preço médio, proximidade e histórico de atendimento para sugerir o prestador perfeito para o seu caso.',
    phoneTitle: 'Match com IA',
    phoneColor: '#5b9cf6',
    mockContent: (
      <div className="sim-phone__match">
        <div className="sim-phone__ai-badge">
          <i className="fas fa-brain"></i> IA Recomendação
        </div>
        <div className="sim-phone__match-card">
          <div className="sim-phone__avatar sim-phone__avatar--ai">R</div>
          <h4>Roberto Silva</h4>
          <p className="sim-phone__match-reason">
            "98% de compatibilidade! Roberto já resolveu 3 casos idênticos ao seu hoje na sua rua."
          </p>
          <div className="sim-phone__match-pct">Match de 98%</div>
        </div>
      </div>
    )
  },
  {
    id: 'pagar',
    title: '3. Garantia',
    subtitle: 'Pagamento 100% Protegido',
    desc: 'Segurança absoluta. O valor pago fica retido na nossa carteira segura e integrada ao Mercado Pago. O prestador só recebe a transferência após você marcar a tarefa como concluída e aprovada.',
    phoneTitle: 'Pagamento Seguro',
    phoneColor: '#10b981',
    mockContent: (
      <div className="sim-phone__pay">
        <div className="sim-phone__payment-card">
          <div className="sim-phone__payment-status">
            <i className="fas fa-lock"></i>
            <span>Pagamento Garantido</span>
          </div>
          <div className="sim-phone__price">R$ 150,00</div>
          <p>Valor custodiado com segurança. Só será liberado após o término do serviço.</p>
          <div className="sim-phone__btn-pay">Aprovar Liberação</div>
        </div>
      </div>
    )
  }
];

export function Home() {
  const [activeScreen, setActiveAppScreen] = useState('buscar');

  return (
    <div className="home-page">
      {/* ── 1. HERO SECTION ────────────────────────────────── */}
      <section className="hp-hero" id="hero">
        <div className="hp-hero__grid"></div>
        <div className="hp-hero__glow"></div>
        <div className="hp-container hp-hero__inner">
          <div className="hp-hero__text">
            <div className="hp-badge">
              <span className="hp-badge__dot"></span>
              Startup de Tecnologia · Recife, PE
            </div>
            <h1 className="hp-hero__headline">
              Democratizando a<br />
              <span className="hp-gradient-text">tecnologia</span> e gerando<br />
              oportunidades reais
            </h1>
            <p className="hp-hero__sub">
              A <strong>Decode Byte</strong> desenvolve soluções digitais inovadoras que conectam pessoas, transformam experiências e impulsionam negócios através da tecnologia.
            </p>
            <div className="hp-hero__ctas">
              <a href="#sobre" className="hp-btn hp-btn--primary hp-btn--large">
                Sobre a Startup <i className="fas fa-arrow-down"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── 2. SOBRE A STARTUP ─────────────────────────────── */}
      <section className="hp-about" id="sobre">
        <div className="hp-container">
          <div className="hp-text-center">
            <div className="hp-section-label">A Startup</div>
            <h2>Foco Absoluto em Impacto Social e Inovação</h2>
            <p className="hp-section-desc">
              Não somos apenas desenvolvedores de código. Somos engenheiros focados em solucionar os gargalos econômicos de quem mais precisa de trabalho e de soluções acessíveis.
            </p>
          </div>

          <div className="hp-about__cards">
            <div className="hp-about__card">
              <div className="hp-about__card-icon">
                <i className="fas fa-bullseye"></i>
              </div>
              <h3>Missão</h3>
              <p>Democratizar a tecnologia e criar pontas seguras de geração de renda para milhões de profissionais autônomos no Brasil.</p>
            </div>
            
            <div className="hp-about__card hp-about__card--featured">
              <div className="hp-about__card-icon">
                <i className="fas fa-eye"></i>
              </div>
              <h3>Visão</h3>
              <p>Ser a principal referência nordestina e nacional em tecnologia social e desenvolvimento de marketplaces de geolocalização inteligentes.</p>
            </div>

            <div className="hp-about__card">
              <div className="hp-about__card-icon">
                <i className="fas fa-heart"></i>
              </div>
              <h3>Valores</h3>
              <p>Inclusão social activa, segurança garantida, transparência radical, inovação ágil com IA e foco irrestrito na experiência mobile-first.</p>
            </div>
          </div>

          {/* Nosso Time Section (Integrated) */}
          <div className="hp-team__section">
            <div className="hp-text-center">
              <div className="hp-section-label">O Time Fundador</div>
              <h2>Quem Faz Acontecer</h2>
              <p className="hp-section-desc">
                Um time apaixonado, multidisciplinar e com histórico de fomento em grandes ecossistemas de tecnologia e impacto social.
              </p>
            </div>

            <div className="hp-team__grid">
              <div className="hp-team__member">
                <div className="hp-team__member-image">
                  <img src="/images/member1.jpeg" alt="James William" />
                </div>
                <h3>James William</h3>
                <span className="hp-team__member-role">CEO & Fundador</span>
                <p className="hp-team__member-bio">
                  Graduado em Análise e Desenvolvimento de Sistemas e especialista em Data Science e Inteligencia Artificial. Gestor de projetos focado em criar soluções que aproximam tecnologia de necessidades sociais reais.
                </p>
              </div>

              <div className="hp-team__member">
                <div className="hp-team__member-image">
                  <img src="/images/member2.jpeg" alt="Stefano Spencer" />
                </div>
                <h3>Stefano Spencer</h3>
                <span className="hp-team__member-role">CTO & Fundador</span>
                <p className="hp-team__member-bio">
                  Graduado em Análise e Desenvolvimento de Sistemas com foco em arquitetura nativa mobile e inteligência artificial. Construtor de sistemas robustos de geolocalização e integração de pagamentos para o Tarefas Perto.
                </p>
              </div>

              <div className="hp-team__member">
                <div className="hp-team__member-image">
                  <img src="/images/member3.jpeg" alt="Renato Dozzo" />
                </div>
                <h3>Renato Dozzo</h3>
                <span className="hp-team__member-role">COO & Fundador</span>
                <p className="hp-team__member-bio">
                  Contabilista graduado e especialista em modelagem e finanças de negócios. Comanda a governança, processos internos sustentáveis e relações comerciais e corporativas da Decode Byte.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── 3. DEMONSTRATIVO TAREFAS PERTO ─────────────────── */}
      <section className="hp-product" id="tarefas-perto">
        <div className="hp-container">
          <div className="hp-text-center">
            <div className="hp-section-label">Nosso Produto Principal</div>
            <h2>Conheça o Tarefas Perto</h2>
            <p className="hp-section-desc">
              Um aplicativo completo que aproxima profissionais autônomos de clientes qualificados. Simples, seguro, rápido e totalmente gratuito para baixar.
            </p>
          </div>

          <div className="hp-product__simulator">
            <div className="hp-product__simulator-controls">
              {SIMULATOR_SCREENS.map(screen => (
                <button
                  key={screen.id}
                  className={`hp-simulator-btn ${activeScreen === screen.id ? 'active' : ''}`}
                  onClick={() => setActiveAppScreen(screen.id)}
                >
                  <span className="hp-simulator-btn__num">{screen.title.split('.')[0]}</span>
                  <div className="hp-simulator-btn__txt">
                    <strong>{screen.subtitle}</strong>
                    <span>{screen.desc.substring(0, 50)}...</span>
                  </div>
                </button>
              ))}

              <div className="hp-product__simulator-info">
                {SIMULATOR_SCREENS.filter(s => s.id === activeScreen).map(screen => (
                  <div key={screen.id} className="hp-sim-detail">
                    <h3>{screen.subtitle}</h3>
                    <p>{screen.desc}</p>
                    <div className="hp-sim-detail__links">
                      <Link to="/tarefas-perto" className="hp-btn hp-btn--primary">
                        Ver Todos os Detalhes <i className="fas fa-arrow-right"></i>
                      </Link>
                    </div>

                    <div className="hp-sim-detail__stores-wrap">
                      <span>Disponível nas lojas:</span>
                      <div className="hp-sim-detail__stores">
                        <a
                          href="https://play.google.com/store/apps/details?id=com.tarefasperto.app"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hp-store-btn hp-store-btn--android hp-store-btn--small"
                        >
                          <i className="fab fa-google-play"></i>
                          <div>
                            <span>Disponível no</span>
                            <strong>Google Play</strong>
                          </div>
                        </a>
                        <a
                          href="https://apps.apple.com/br/app/tarefas-perto/id6757638488"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hp-store-btn hp-store-btn--ios hp-store-btn--small"
                        >
                          <i className="fab fa-apple"></i>
                          <div>
                            <span>Disponível na</span>
                            <strong>App Store</strong>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Simulação Celular Interativa */}
            <div className="hp-product__simulator-phone">
              {SIMULATOR_SCREENS.filter(s => s.id === activeScreen).map(screen => (
                <div key={screen.id} className="sim-phone">
                  <div className="sim-phone__notch"></div>
                  <div className="sim-phone__header" style={{ backgroundColor: screen.phoneColor }}>
                    <i className="fas fa-signal"></i>
                    <span>{screen.phoneTitle}</span>
                    <i className="fas fa-battery-three-quarters"></i>
                  </div>
                  <div className="sim-phone__body">
                    {screen.mockContent}
                  </div>
                  <div className="sim-phone__home-indicator"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── 4. APOIO INSTITUCIONAL ─────────────────────────── */}
      <section className="hp-credibility" id="credibilidade">
        <div className="hp-container">
          <div className="hp-text-center">
            <div className="hp-section-label">Credibilidade & Parcerias</div>
            <h2>Apoio</h2>
            <p className="hp-section-desc">
              O Tarefas Perto e a Decode Byte contam com o apoio e chancela de grandes referências em empreendedorismo, aceleração e pesquisa do Nordeste do Brasil.
            </p>
          </div>

          <div className="hp-partners-grid">
            {PARTNERS.map(partner => (
              <div key={partner.key} className="hp-partner-card">
                <div className="hp-partner-card__header">
                  <div className={`hp-partner-card__logo-wrapper ${partner.logos ? 'hp-partner-card__logo-wrapper--dual' : ''} ${partner.key === 'facepe' ? 'hp-partner-card__logo-wrapper--facepe' : ''}`}>
                    {partner.logos ? (
                      partner.logos.map((logo, index) => (
                        <img key={index} src={logo.src} alt={logo.alt} className="hp-partner-card__logo" />
                      ))
                    ) : (
                      <img src={partner.logo} alt={partner.name} className="hp-partner-card__logo" />
                    )}
                  </div>
                  <h3>{partner.name}</h3>
                </div>

                <p className="hp-partner-card__desc">{partner.desc}</p>

                <ul className="hp-partner-card__list">
                  {partner.items.map((item, idx) => (
                    <li key={idx} className="hp-partner-card__list-item">
                      <span className="hp-partner-card__bullet">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 3L4.5 8.5L2 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </span>
                      <span>{item.label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 5. METRICAS / NÚMEROS ──────────────────────────── */}
      <section className="hp-metrics">
        <div className="hp-container">
          <div className="hp-metrics__grid">
            <div className="hp-metric">
              <div className="hp-metric__number">3</div>
              <div className="hp-metric__label">Parceiros Institucionais</div>
            </div>
            <div className="hp-metric">
              <div className="hp-metric__number"><i className="fas fa-rocket"></i></div>
              <div className="hp-metric__label">Entre as 80 Startups Selecionadas (Startup NE)</div>
            </div>
            <div className="hp-metric">
              <div className="hp-metric__number">2025</div>
              <div className="hp-metric__label">Fomento FACEPE Pró-Startups</div>
            </div>
          </div>
        </div>
      </section>

      {/* ── 6. CTA FINAL ───────────────────────────────────── */}
      <section className="hp-cta-final" id="cta">
        <div className="hp-container">
          <div className="hp-cta-final__card">
            <h2>Pronto para fazer parte dessa transformação?</h2>
            <p>Seja como profissional autônomo querendo multiplicar seus ganhos, como cliente querendo economizar tempo ou como parceiro estratégico.</p>
            <div className="hp-cta-final__actions">
              <Link to="/contato" className="hp-btn hp-btn--primary hp-btn--large">
                Fale Conosco <i className="fas fa-envelope"></i>
              </Link>
              <Link to="/sobre" className="hp-btn hp-btn--ghost hp-btn--large">
                Conheça Nossa Equipe
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
